import { apiPrivate } from "../apiCall";
import { useEffect } from "react";
import useAuth from "./useAuth";
import { useLocation, useNavigate } from "react-router-dom";

const useApiPrivate = () => {
    const { auth,setAuth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

 
    useEffect(() => {
        const requestIntercept = apiPrivate.interceptors.request.use(
                // Do something before request is sent
            config => {
                config.headers['Authorization'] = `Bearer ${auth?.token}`;
                // config.headers['Authorization'] = `Bearer 52|LkIqVo8tMEBMpIzBACeSqzbwVGn1vUrWq85bTTmd`;
                return config;
            }, (error) => Promise.reject(error)
            );
            const responseIntercept = apiPrivate.interceptors.response.use(
                response => response,
                // if token expire run the handle error
                async (error) => {
                    if (error?.response?.status === 401) {
                        setAuth('');
                        localStorage.removeItem('auth');
                        navigate('/login', {replace: true, state: {from: location}});
                    return apiPrivate();
                }
                    if (error?.response?.status === 404) {
                        navigate('*', {replace: true});
                    return apiPrivate();
                    }
                return Promise.reject(error);
            }
        );
        return () => {
            apiPrivate.interceptors.request.eject(requestIntercept);
            apiPrivate.interceptors.response.eject(responseIntercept);
        }
    },[auth])
    return apiPrivate;
}

export default useApiPrivate;